export default "__VITE_ASSET__BiEp8a$Q__"